module.exports = __webpack_public_path__ + "static/media/league-nav-prize-breakup-disabled.88e95a19.svg";